import Vue from 'vue';
import i18n from "@/plugins/vueI18n";

export const fileSizeToMB = (size: number) => {
  if(size) {
    return size / (1024 * 1024);
  }

  return null;
}

export const validFileSize10MB = (size: number) => {
  if(size && size > 10) {
    const message: string = i18n.messages[i18n.locale]['GeneralTranslations.ImageMustBeUnder10MegabytesErrorMessage'].toString();

    Vue.$toast.open({
      message: message,
      type: "error"
    });

    return false;
  }

  return true;
}

export const validVideoSize200MB = (size: number) => {
  if(size && size > 10) {
    const message: string = i18n.messages[i18n.locale]['GeneralTranslations.VideoMustBeUnder200MegabytesErrorMessage'].toString();

    Vue.$toast.open({
      message: message,
      type: "error"
    });

    return false;
  }

  return true;
}